import React, {createContext, useContext, useReducer} from "react";
import { checkForFilters } from "../utils/data";

const FilterContext = createContext({});
const FilterDispatchContext = createContext({});

export function getURLParamValue(search, param) {
    const urlParams = new URLSearchParams(search);
    if (param === "phase" || param === "performance" || param === "map" || param === "type" || param === "year" || param === "admin" || param === "mapped") {
        return urlParams.has(param) ? urlParams.get(param).split(";") : [];
    }

    return urlParams.has(param) ? urlParams.get(param) : "";
}

export function getPage(pathname) {
    const path = pathname.substr(1, pathname.length);
    return path.indexOf("projects") !== -1 ? "projects" : "home";
}

function urlParamHasValues(search) {
    return search && search.length > 0 ? true : false;
}

export const emptyFilters = {
    page: "",
    search: "",
    location: {
        city: {
            selectedLocation: "",
            name: "city",
            displayName: "City",
            attributeName: "FME_CITY"
        },
        county: {
            selectedLocation: "",
            name: "county",
            displayName: "County",
            attributeName: "FME_COUNTY"
        },
        region: {
            selectedLocation: "",
            name: "region",
            displayName: "Region",
            attributeName: "FME_REGION"
        },
        act: {
            selectedLocation: "",
            name: "act",
            displayName: "ACT",
            attributeName: "FME_ACT"
        },
        mpo: {
            selectedLocation: "",
            name: "mpo",
            displayName: "MPO",
            attributeName: "FME_MPO"
        },
        congDistrict: {
            selectedLocation: "",
            name: "congDistrict",
            displayName: "Congressional District",
            attributeName: "FME_US_CNGR_DIST"
        },
        houseDistrict: {
            selectedLocation: "",
            name: "houseDistrict",
            displayName: "House District",
            attributeName: "FME_STATE_REP_DIST"
        },
        senateDistrict: {
            selectedLocation: "",
            name: "senateDistrict",
            displayName: "Senate District",
            attributeName: "FME_STATE_SEN_DIST"
        }
    },
    phase: [],
    performance: [],
    year: [],
    type: [],
    admin: [],
    map: [],
    mapPoint: "",
    updatedFilter: "",
    selectedForSnapshot: "",
    selectedForList: [],
    mapped: [],
    extent: null
};

const initLocation = {
    pathname: window.location.pathname,
    search: window.location.search
};

export const adminFilterOps = [
    {
        display: "Federal Highway Administration",
        val: "WFLHD"
    },
    {
        display: "Idaho Department of Transportation",
        val: "IDAHODOT"
    },
    {
        display: "Local agency",
        val: "LOCAL"
    },
    {
        display: "Oregon Department of Transportation",
        val: "ODOT"
    },
    {
        display: "Oregon Parks and Recreation Department",
        val: "OPRD"
    },
    {
        display: "Washington Department of Transportation",
        val: "WASHDOT"
    }
];

export function getFiltersFromUrl(pathname, search) {
    let filters = {
        page: getPage(pathname),
        search: getURLParamValue(search, "search"),
        location: {
            city: {
                selectedLocation: getURLParamValue(search, "city"),
                name: "city",
                displayName: "City",
                attributeName: "FME_CITY"
            },
            county: {
                selectedLocation: getURLParamValue(search, "county"),
                name: "county",
                displayName: "County",
                attributeName: "FME_COUNTY"
            },
            region: {
                selectedLocation: getURLParamValue(search, "region"),
                name: "region",
                displayName: "Region",
                attributeName: "FME_REGION"
            },
            act: {
                selectedLocation: getURLParamValue(search, "act"),
                name: "act",
                displayName: "ACT",
                attributeName: "FME_ACT"
            },
            mpo: {
                selectedLocation: getURLParamValue(search, "mpo"),
                name: "mpo",
                displayName: "MPO",
                attributeName: "FME_MPO"
            },
            congDistrict: {
                selectedLocation: getURLParamValue(search, "congDistrict"),
                name: "congDistrict",
                displayName: "Congressional District",
                attributeName: "FME_US_CNGR_DIST"
            },
            houseDistrict: {
                selectedLocation: getURLParamValue(search, "houseDistrict"),
                name: "houseDistrict",
                displayName: "House District",
                attributeName: "FME_STATE_REP_DIST"
            },
            senateDistrict: {
                selectedLocation: getURLParamValue(search, "senateDistrict"),
                name: "senateDistrict",
                displayName: "Senate District",
                attributeName: "FME_STATE_SEN_DIST"
            }
        },
        phase: getURLParamValue(search, "phase"),
        performance: getURLParamValue(search, "performance"),
        year: getURLParamValue(search, "year"),
        type: getURLParamValue(search, "type"),
        admin: getURLParamValue(search, "admin"),
        map: getURLParamValue(search, "map"),
        mapPoint: getURLParamValue(search, "mapPoint"),
        updatedFilter: urlParamHasValues(search) ? "urlParams" : "",
        selectedForSnapshot: pathname && pathname.lastIndexOf("/") > 4 ? pathname.substring(pathname.lastIndexOf("/") + 1, pathname.length) : "",
        selectedForList: [],
        mapped: getURLParamValue(search, "mapped"),
        extent: null
    };
    
    return filters;
}

function reducer(filters, action) {
    switch(action.type) {
        case 'page':
            return {
                ...filters,
                page: action.payload,
                search: "",
                location: emptyFilters.location,
                phase: [],
                performance: [],
                year: [],
                type: [],
                admin: [],
                map: [],
                mapPoint: "",
                updatedFilter: checkForFilters(filters) ? "pagePlus" : "page",
                selectedForSnapshot: "",
                selectedForList: [],
                mapped: [],
                extent: null
            };
        case 'search':
            return {
                ...filters,
                page: action.pagePayload,
                search: action.payload,
                updatedFilter: "search",
                selectedForSnapshot: "",
                selectedForList: [],
                mapPoint: "",
                extent: null
            };
        case 'location':
            switch(action.subtype) {
                case 'city':
                    return {
                        ...filters,
                        page: action.pagePayload,
                        location: {...filters.location, city: {...filters.location.city, selectedLocation: action.payload}},
                        updatedFilter: "location",
                        selectedForSnapshot: "",
                        mapPoint: "",
                        extent: null,
                        selectedForList: []
                    };
                case 'county':
                    return {
                        ...filters,
                        page: action.pagePayload,
                        location: {...filters.location, county: {...filters.location.county, selectedLocation: action.payload}},
                        updatedFilter: "location",
                        selectedForSnapshot: "",
                        mapPoint: "",
                        extent: null,
                        selectedForList: []
                    };
                case 'region':
                    return {
                        ...filters,
                        page: action.pagePayload,
                        location: {...filters.location, region: {...filters.location.region, selectedLocation: action.payload}},
                        updatedFilter: "location",
                        selectedForSnapshot: "",
                        mapPoint: "",
                        extent: null,
                        selectedForList: []
                    };
                case 'act':
                    return {
                        ...filters,
                        page: action.pagePayload,
                        location: {...filters.location, act: {...filters.location.act, selectedLocation: action.payload}},
                        updatedFilter: "location",
                        selectedForSnapshot: "",
                        mapPoint: "",
                        extent: null,
                        selectedForList: []
                    };
                case 'mpo':
                    return {
                        ...filters,
                        page: action.pagePayload,
                        location: {...filters.location, mpo: {...filters.location.mpo, selectedLocation: action.payload}},
                        updatedFilter: "location",
                        selectedForSnapshot: "",
                        mapPoint: "",
                        extent: null,
                        selectedForList: []
                    };
                case 'congDistrict':
                    return {
                        ...filters,
                        page: action.pagePayload,
                        location: {...filters.location, congDistrict: {...filters.location.congDistrict, selectedLocation: action.payload}},
                        updatedFilter: "location",
                        selectedForSnapshot: "",
                        mapPoint: "",
                        extent: null,
                        selectedForList: []
                    };
                case 'houseDistrict':
                    return {
                        ...filters,
                        page: action.pagePayload,
                        location: {...filters.location, houseDistrict: {...filters.location.houseDistrict, selectedLocation: action.payload}},
                        updatedFilter: "location",
                        selectedForSnapshot: "",
                        mapPoint: "",
                        extent: null,
                        selectedForList: []
                    };
                case 'senateDistrict':
                    return {
                        ...filters,
                        page: action.pagePayload,
                        location: {...filters.location, senateDistrict: {...filters.location.senateDistrict, selectedLocation: action.payload}},
                        updatedFilter: "location",
                        selectedForSnapshot: "",
                        mapPoint: "",
                        extent: null,
                        selectedForList: []
                    };
                default:
                    throw new Error('unhandled action subtype: ' + action.subtype);
            };
        case 'phase':
            if (filters.phase.includes(action.payload)) {
                let newPhase = filters.phase.filter(phase => phase !== action.payload);
                return {
                    ...filters,
                    page: action.pagePayload,
                    phase: newPhase,
                    updatedFilter: "phase",
                    selectedForSnapshot: "",
                    //selectedForList: filters.selectedForList.length && !filters.mapPoint ? filters.selectedForList : []
                };
            }

            let newPhase = filters.phase.concat([action.payload]);
            return {
                ...filters,
                page: action.pagePayload,
                phase: newPhase,
                updatedFilter: "phase",
                selectedForSnapshot: "",
                //selectedForList: filters.selectedForList.length && !filters.mapPoint ? filters.selectedForList : []
            };
        case 'performance':
            if (filters.performance.includes(action.payload)) {
                let newPerf = filters.performance.filter(performance => performance !== action.payload);
                return {
                    ...filters,
                    page: action.pagePayload,
                    performance: newPerf,
                    updatedFilter: "performance",
                    selectedForSnapshot: ""
                };
            }

            let newPerf = filters.performance.concat([action.payload]);
            return {
                ...filters,
                page: action.pagePayload,
                performance: newPerf,
                updatedFilter: "performance",
                selectedForSnapshot: ""
            };
        case 'year':
            if (filters.year.includes(action.payload)) {
                let newYear = filters.year.filter(year => year !== action.payload);
                return {
                    ...filters,
                    page: action.pagePayload,
                    year: newYear,
                    updatedFilter: "year",
                    selectedForSnapshot: ""
                }
            }

            let newYear = filters.year.concat([action.payload]);
            return {
                ...filters,
                page: action.pagePayload,
                year: newYear,
                updatedFilter: "year",
                selectedForSnapshot: ""
            };
        case 'type':
            if (filters.type.includes(action.payload)) {
                let newType = filters.type.filter(type => type !== action.payload);
                return {
                    ...filters,
                    page: action.pagePayload,
                    type: newType,
                    updatedFilter: "type",
                    selectedForSnapshot: ""
                }
            }

            let newType = filters.type.concat([action.payload]);
            return {
                ...filters,
                page: action.pagePayload,
                type: newType,
                updatedFilter: "type",
                selectedForSnapshot: ""
            };
        case 'admin':
            if (filters.admin.includes(action.payload)) {
                let newAdmin = filters.admin.filter(admin => admin !== action.payload);
                return {
                    ...filters,
                    page: action.pagePayload,
                    admin: newAdmin,
                    updatedFilter: "admin",
                    selectedForSnapshot: ""
                }
            }

            let newAdmin = filters.admin.concat([action.payload]);
            return {
                ...filters,
                page: action.pagePayload,
                admin: newAdmin,
                updatedFilter: "admin",
                selectedForSnapshot: ""
            };
        case 'clearFilters':
            return {
                ...filters,
                page: "projects",
                search: "",
                location: emptyFilters.location,
                phase: [],
                performance: [],
                year: [],
                type: [],
                admin: [],
                map: filters.map.includes("show") ? filters.map : [],
                mapPoint: "",
                updatedFilter: "pagePlus",
                selectedForSnapshot: "",
                selectedForList: [],
                mapped: [],
                extent: null
            };
        case 'mobileProjects':
            if (filters.map.includes("show")) {
                let newMap = filters.map.filter(map => map !== "show");
                return {
                    ...filters,
                    page: action.payload,
                    map: newMap,
                    updatedFilter: "page",
                    selectedForSnapshot: ""
                }
            }

            return {
                ...filters,
                page: "projects",
                updatedFilter: "page",
                selectedForSnapshot: ""
            };
        case 'mobileMap':
            if (filters.map.includes(action.payload)) {
                let newMap = filters.map.filter(map => map !== action.payload);
                return {
                    ...filters,
                    map: newMap,
                    updatedFilter: "page",
                    selectedForSnapshot: ""
                };
            }

            let newMap = filters.map.concat([action.payload]);
            return {
                ...filters,
                page: "projects",
                map: newMap,
                updatedFilter: "page",
                selectedForSnapshot: ""
            };
        case 'fullscreen':
            return {
                ...filters,
                map: filters.map.includes(action.payload) ? filters.map.filter(map => map !== action.payload) : filters.map.concat([action.payload]),
                updatedFilter: "fullscreen"
            };
        case 'mapPoint':
            return {
                ...filters,
                page: action.pagePayload,
                mapPoint: action.payload,
                updatedFilter: action.updatedFilterPayload ? action.updatedFilterPayload : "mapPoint",
                selectedForSnapshot: action.selectedForSnapshotPayload ? action.selectedForSnapshotPayload : "",
                selectedForList: action.projectPayload,
                map: action.payload === "" ? filters.map : [],
                extent: action.extentPayload
            };
        case 'urlFilterUpdate':
            if (action.selectedForListPayload) {
                return {
                    ...filters,
                    page: action.pagePayload,
                    search: action.searchPayload,
                    location: action.locationPayload,
                    phase: action.phasePayload,
                    performance: action.performancePayload,
                    year: action.yearPayload,
                    type: action.typePayload,
                    admin: action.adminPayload,
                    map: action.mapPayload,
                    mapPoint: action.mapPointPayload,
                    updatedFilter: action.updatedFilter,
                    selectedForList: action.selectedForListPayload,
                    mapped: action.mappedPayload,
                    extent: null
                }
            }
            if (action.selectedForSnapshotPayload) {
                return {
                    ...filters,
                    page: action.pagePayload,
                    search: action.searchPayload,
                    location: action.locationPayload,
                    phase: action.phasePayload,
                    performance: action.performancePayload,
                    year: action.yearPayload,
                    type: action.typePayload,
                    admin: action.adminPayload,
                    map: action.mapPayload,
                    mapPoint: action.mapPointPayload,
                    updatedFilter: action.updatedFilter,
                    selectedForSnapshot: action.selectedForSnapshotPayload,
                    mapped: action.mappedPayload
                }
            }
            else {
              return {
                    ...filters,
                    page: action.pagePayload,
                    search: action.searchPayload,
                    location: action.locationPayload,
                    phase: action.phasePayload,
                    performance: action.performancePayload,
                    year: action.yearPayload,
                    type: action.typePayload,
                    admin: action.adminPayload,
                    map: action.mapPayload,
                    mapPoint: action.mapPointPayload,
                    updatedFilter: action.updatedFilter === "mapPoint" ? "" : action.updatedFilter,
                    mapped: action.mappedPayload
                }  
            };  
        case 'projectForSnapshot':
            return {
                ...filters,
                page: "",
                selectedForSnapshot: action.payload,
                updatedFilter: "snapshot"
            };
        case 'projectsForList':
            return {
                ...filters,
                page: action.pagePayload,
                selectedForList: action.payload,
                updatedFilter: action.updatedFilterPayload,
                extent: action.extentPayload,
                
            };
        case 'mapped':
            if (filters.mapped.includes(action.payload)) {
                let newMapped = filters.mapped.filter(mapped => mapped !== action.payload);
                return {
                    ...filters,
                    page: action.pagePayload,
                    mapped: newMapped,
                    updatedFilter: "mapped",
                    selectedForSnapshot: ""
                };
            }

            let newMapped = filters.mapped.concat([action.payload]);
            return {
                ...filters,
                page: action.pagePayload,
                mapped: newMapped,
                updatedFilter: "mapped",
                selectedForSnapshot: ""
            };
        default: {
            throw new Error('unhandled action type: ' + action.type);
        }
    }
}

function FilterContextProvider({ children }) {
    const initFilters = getFiltersFromUrl(initLocation.pathname, initLocation.search);
    const [filters, dispatch] = useReducer(reducer, initFilters);
    return (
        <FilterContext.Provider value={filters}>
            <FilterDispatchContext.Provider value={dispatch}>
                {children}
            </FilterDispatchContext.Provider>
        </FilterContext.Provider>
    );
}

export function useFilterContext() {
    const context = useContext(FilterContext);
    if (context === undefined) {
        throw new Error("Context must be used within a Provider");
    }
    return context;
}

export function useFilterDispatch() {
    const context = useContext(FilterDispatchContext);
    if (context === undefined) {
        throw new Error('useFilterDispatch must be used within a FilterContextProvider')
    }
    return context
}

export default FilterContextProvider;